import { useState } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

function useUploadFile() {
    const [file, setFile] = useState(null);

    const formatString = (str) => {
        return str.replace(/\s+/g, '-').toLowerCase();
    }

    const uploadToS3 = async (uploadUrl, file, fileType) => {
        return axios.put(uploadUrl, file, {
            headers: {
                'Content-type': fileType,
                'Access-Control-Allow-Origin': '*',
            },
        });
    };

    const uploadFile = async (postId, carouselId, fileOrUrl, link) => {

        if (!fileOrUrl) {
            return;
        }

        try {
            let file, fileType;
            if (typeof fileOrUrl === 'string') {
                // It's a URL from Unsplash
                const response = await axios.get('/api/proxy-image', {
                    params: { url: fileOrUrl },
                    responseType: 'arraybuffer',
                });
                file = Buffer.from(response.data, 'binary');
                fileType = response.headers['content-type'];
            } else {
                // It's a File object from local upload
                file = fileOrUrl;
                fileType = file.type;
            }

            const date = new Date();
            const formattedDate = format(date, 'yyyyMMddHHmmss');
            const fileKey = `mydata/${formattedDate}/${formatString(file.name || 'file')}.${fileType.split('/')[1]}`;

            const { data } = await axios.post('/api/media/upload_file', {
                file_key: fileKey,
                type: fileType,
                post_id: postId,
                carousel_id: carouselId || null,
                link: link || '',
            });

            await uploadToS3(data.uploadUrl, file, fileType);

            setFile(null);
            return { success: true, url: data.publicUrl, recordId: data.recordId, fileType: fileType.split('/')[0] };
        } catch (error) {
            console.error('Error uploading file:', error);
            return { success: false };
        }
    };

    return { file, setFile, uploadFile };
}

export default useUploadFile;
